(() => {
  function Carousel(carouselElement) {
    const items = carouselElement.querySelectorAll(".carousel-v2__item");
    const numberOfItems = items.length;
    const firstItemDelay = items[0].dataset.carouselDelay;
    const progressBarElement = carouselElement.querySelector(
      ".carousel-v2__progress-bar",
    );
    const progressRefreshRate = parseInt(
      progressBarElement.dataset.carouselProgressRefreshRate,
      10,
    );
    const progressElement = carouselElement.querySelector(
      ".carousel-v2__progress",
    );
    const totalDelay = parseInt(
      progressBarElement.dataset.carouselProgressDelay,
      10,
    );
    let elapsedTime = 0;

    this.nextItem = (index) => {
      let currentItem = items[index];

      currentItem.classList.remove("carousel-v2__item--active");
      index = (index + 1) % numberOfItems;
      currentItem = items[index];
      currentItem.classList.add("carousel-v2__item--active");

      setTimeout(() => this.nextItem(index), currentItem.dataset.carouselDelay);
    };

    this.updateProgress = () => {
      if (elapsedTime > totalDelay) {
        carouselElement.dispatchEvent(new Event("progress_finished"));
        return;
      }

      elapsedTime += progressRefreshRate;
      progressElement.style.width = `${(elapsedTime / totalDelay) * 100}%`;
    };

    // Handle the image changes
    setTimeout(() => this.nextItem(0), firstItemDelay);

    // Handle the progress bar
    this.updateProgress();
    const progressInterval = setInterval(
      this.updateProgress,
      progressRefreshRate,
    );

    carouselElement.addEventListener("progress_finished", () => {
      clearInterval(progressInterval);
    });
  }

  // Assuming there could be more than one carousel on the page
  const startCarousels = () =>
    document.querySelectorAll(".carousel-v2").forEach((carouselElement) => {
      Carousel(carouselElement);
    });

  // On page load, start the carousel
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", startCarousels);
  } else {
    startCarousels();
  }
})();
